import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

const LANGUAGE_PREFIX = /^\/(en|ro|fr)(?=\/|$)/;

// First path segment (after the language prefix) -> metadata key.
const PAGES = {
    '': 'home',
    tutoring: 'tutoring',
    schools: 'schools',
    features: 'features',
    subscriptions: 'pricing',
    about: 'about',
    tutorial: 'tutorial',
    contactus: 'contact',
};

const setMeta = (selector, attr, value) => {
    const el = document.head.querySelector(selector);
    if (el) {
        el.setAttribute(attr, value);
    }
};

/**
 * Title, description, social tags, canonical and the html lang for the public
 * pages, in the visitor's language. index.html carries the English home page
 * values for crawlers that do not run scripts; this keeps the other pages and
 * languages from all reporting the home page's English metadata.
 */
const PageMeta = () => {
    const { pathname } = useLocation();
    const intl = useIntl();

    useEffect(() => {
        const path = pathname.replace(LANGUAGE_PREFIX, '');
        const page = PAGES[path.split('/').filter(Boolean)[0] || ''];
        document.documentElement.lang = intl.locale;
        if (!page) {
            return;
        }
        const title = intl.formatMessage({ id: `meta.${page}.title` });
        const description = intl.formatMessage({ id: `meta.${page}.description` });
        const url = 'https://vboard.ro' + (pathname === '/' ? '/' : pathname.replace(/\/$/, ''));

        document.title = title;
        setMeta("meta[name='description']", 'content', description);
        setMeta("meta[property='og:title']", 'content', title);
        setMeta("meta[property='og:description']", 'content', description);
        setMeta("meta[property='og:url']", 'content', url);
        setMeta("meta[name='twitter:title']", 'content', title);
        setMeta("meta[name='twitter:description']", 'content', description);
        setMeta("link[rel='canonical']", 'href', url);
    }, [pathname, intl]);

    return null;
};

export default PageMeta;
